import React from 'react';
import Typography from '../shared/Typography';
import cx from 'classnames';

export type Content = {
  type: 'paragraph' | 'list' | 'title';
  content: string | string[];
};

type Props = {
  title: string;
  paragraphs: Content[];
};

const TextPage: React.FC<Props> = ({ title, paragraphs }) => {
  return (
    <div
      className={cx(
        'xl:w-1264 text-justify xl:pl-48 pt-16 xl:pb-9 px-6 xl:px-0'
      )}
    >
      <Typography type="h1" className="mb-8">
        {title}
      </Typography>
      {paragraphs.map((p: Content, key) => {
        if (p.type === 'paragraph') {
          return (
            <div key={key} className="mb-8">
              <Typography type="b3">{p.content}</Typography>
            </div>
          );
        }

        if (p.type === 'title') {
          return (
            <div key={key} className="mb-2">
              <Typography type="b3b">{p.content}</Typography>
            </div>
          );
        }

        if (p.type === 'list') {
          return (
            <div key={key} className="mb-8">
              <ul style={{ listStyleType: 'circle' }}>
                {(p.content as string[]).map((item: string, idx: number) => (
                  <li key={idx}>
                    <Typography type="b3">{item}</Typography>
                  </li>
                ))}
              </ul>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default TextPage;
